import React from 'react';
import { Helmet } from 'react-helmet-async';

// Static layout sections
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import MissionStatement from '../components/MissionStatement';
import FeatureHighlights from '../components/FeatureHighlights';
import CustomerConfidence from '../components/CustomerConfidence';
import HowItWorks from '../components/HowItWorks';
import SearchSpotlight from '../components/SearchSpotlight';
import WhyTrustUs from '../components/WhyTrustUs';
import Footer from '../components/Footer';
import ChatbotModal from '../components/ChatBotAi/ChatBotAi';



// Dynamic data sections
import TrendingProducts from '../features/TrendingProducts';
import TopCategories from '../features/TopCategories';
import CuratedSegments from '../features/CuratedSegments';

const HomePage = () => {
  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>KambiHome - Shop Smarter, Live Better</title>
        <meta name="description" content="Discover top AliExpress products curated for Nigerian buyers. Fast shipping, trusted categories, smart filters." />
        <meta name="keywords" content="AliExpress Nigeria, trending products, smart shopping, best deals, top categories" />
        <link rel="canonical" href="https://kambihome.com/" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="KambiHome - Discover Smart Shopping" />
        <meta property="og:description" content="Explore trusted AliExpress products tailored for you. Curated by category and trends." />
        <meta property="og:image" content="https://kambihome.com/segments/seobanner.png" />
        <meta property="og:url" content="https://kambihome.com/" />
        <meta property="og:type" content="website" />

        {/* Twitter Tags */}
        <meta name="twitter:title" content="KambiHome - Discover Smart Shopping" />
        <meta name="twitter:description" content="Explore trusted AliExpress products tailored for you. Curated by category and trends." />
        <meta name="twitter:image" content="https://kambihome.com/segments/seobanner.png" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <Header />
      <main className="mt-16 scroll-smooth">
        <HeroSection />
        <MissionStatement />
        <TrendingProducts />
        <FeatureHighlights />
        <TopCategories />
        <CustomerConfidence />
        <CuratedSegments />
        <HowItWorks />
        <SearchSpotlight />
        <WhyTrustUs />
      </main>
      <Footer />
      <ChatbotModal />
    </>
  );
};

export default HomePage;
